import { Component, OnInit } from '@angular/core';
import { CanActivate } from '@angular/router/src/utils/preactivation';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
